<template>
  <div class="marges-page" v-show="image != null">
    <div class="panneau" v-if="image != null">
        <a class="btn-close" v-on:click="close()"></a>
        <div class="info-pane__col1">
            <div class="info-pane__photo-wrapper">
                <div class="badge-magnifier-plus"></div>
                <Photoswipe>
                  <img v-bind:src="image.src" v-bind:data-pswp-src="image.src" alt="" class="info-pane__photo">
                </Photoswipe>
            </div>
        </div>
        <div class="info-pane__col2">
                <h1 class="info-pane__title" v-if="image.year">{{ image.year_full || image.year }}</h1>
                <h2 class="item-share__title">{{ image.location || '?' }}</h2>
            <div class="item-info">
                <p class="item-info__description" v-if="image.caption">{{ image.caption  }}</p>
            </div>
        </div>
        <div class="info-pane__col3">
            <h1 class="item-share__title">Partager<br>la photo</h1>
            <div class="item-share__form w-form" v-on:click="focusForm()">
                <form id="email-form" lass="form" method="POST" action="/api/send-postcard.php" ref="emailForm" @submit.prevent="sendEmail">
                    <div>
                      <label for="msg-email" class="form-label">E-mail des destinataires</label>
                      <selectize type="email" name="recipient_email[]" data-name="E-mail des destinataires" id="msg-email" required="" :settings="emailFieldOptions"> 
                      </selectize>
                      
                      <label for="msg-name" class="form-label">Mon nom</label>
                      <input type="text" class="form-text w-input" maxlength="256" name="sender_name" data-name="Name" id="msg-name">
                      
                      <label for="msg-sender-email" class="form-label">Mon e-mail</label>
                      <input type="email" class="form-text w-input" maxlength="256" name="email" data-name="sender_email" id="msg-sender-email" required="">
                      
                      <input type="checkbox" class="form-text w-input" name="copy" data-name="send_copy" id="msg-sender-copy">
                      <label for="msg-sender-copy" class="form-label">Merci de m’envoyer une copie</label>
                    </div>
                    
                    <input type="submit" v-bind:disabled="processing" value="Envoyer" data-wait="Please wait..." class="primary-btn w-button" ref="sendEmailButton">
                </form>
            </div>
        </div>
    </div>
    <div class="fond-panneau"></div>

</div>
</template>

<script>

import JQuery from 'jquery';
let $ = JQuery;
import _ from 'lodash';
import Vue from 'vue';
import Selectize from 'vue2-selectize';

import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes});

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

Vue.use(VueNotifications, {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
});

var REGEX_EMAIL = '([a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@' +
              '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)';

export default {
  name: 'GalleryDetail',
  props: {
    msg: String
  },
  components: {
    'selectize': Selectize
  },
  data: function () {

    return {
      image: null,
      processing: false,
      emailFieldOptions: {
          persist: false,
          maxItems: null,
          delimiter: ',',
          plugins: ['remove_button'],
          valueField: 'email',
          labelField: 'name',
          createOnBlur: true,
          searchField: ['name', 'email'],
          options: [
              //
          ],
          render: {
              item: function(item, escape) {
                  return '<div>' +
                      (item.name ? '<span class="name">' + escape(item.name) + '</span>' : '') +
                      (item.email ? '<span class="email">' + escape(item.email) + '</span>' : '') +
                      '</div>';
              },
              option: function(item, escape) {
                  var label = item.name || item.email;
                  var caption = item.name ? item.email : null;
                  return '<div>' +
                      '<span class="label">' + escape(label) + '</span>' +
                      (caption ? '<span class="caption">' + escape(caption) + '</span>' : '') +
                      '</div>';
              }
          },
          create: function(input) {
              if ((new RegExp('^' + REGEX_EMAIL + '$', 'i')).test(input)) {
                  return {email: input};
              }
              var match = input.match(new RegExp('^([^<]*)\<' + REGEX_EMAIL + '\>$', 'i'));
              if (match) {
                  return {
                      email : match[2],
                      name  : $.trim(match[1])
                  };
              }
              alert('Email invalide.');
              return false;
          }
      }
    };

  },

  mounted: function () {
    //
  },

  methods: {

    setData: function (image) {
      this.image = image;
    },

    close: function () {
      this.image = null;
    },

    sendEmail: function () {

      var self = this;

      var $messageForm = $(this.$el).find('#email-form');
      var formData = $messageForm.serializeArray();
      this.processing = true;

      formData = formData.concat([
          { 
            name: 'postcard_id', 
            value: self.image.id 
          },
          {
            name: 'message', 
            value: "Salut!<br><br>J’étais au Musée des Mascarons et cette photographie de Daniel Schelling m’a beaucoup plu.<br><br>" 
                    + "<h2>" + (self.image.year || '-') + " - " + (self.image.location || '-') + "</h2>"
                    + "<br>"  + (self.image.caption || '-')
          }
      ]);         

      var postMessage = $.post( $messageForm.attr('action'), formData );
      postMessage.done(function (data) {

          console.log('send email', data);

          if (data) {
              self.showMailError();
          } else {
              self.image = null;
              self.showMailSuccess();
          }

          self.processing = false;
      });
    },

    focusForm: function () {
      var container = this.$el.querySelector('.info-pane__col3');
      window.setTimeout(function () {
        container.scrollTop = container.scrollHeight;
      }, 50);
    }

  },

  notifications: {
    showMailSuccess: { 
      title: 'MRVT',
      message: 'Message envoyé avec succès',
      type: 'success'
    },
    showMailError: { 
      title: 'MRVT',
      message: "Une erreur est survenue lors de l'envoi du message",
      type: 'error'
    }
  }

} 
</script>   

<style lang="scss">

.title {
  color: #d42c2c;
  font-size: 44px;
}

.btn-close {
  position: absolute;
  top: 87px;
  right: 41px;
  height: 48px;
  width: 48px;

  background-image: url('../assets/close-icon.svg');
  background-position: 50% 50%;
  background-size: contain;
  background-repeat: no-repeat;
}

.pswp__top-bar,
.pswp__button--fs,
.pswp__button--close {
  display: none!important;
}

.item-info__title {
  margin-top: 47px;
  color: #000;
  font-size: 35px;
  line-height: 42px;
  font-weight: 600;
}

.info-pane__title {
  margin-top: 0px;
  margin-bottom: 0px;
  color: #000;
  font-size: 65px;
  line-height: 78px;
  font-weight: 900;
}

.info-pane__photo {
  display: block;
  max-height: 640px;
  max-width: 100%;
  margin: auto;
  box-shadow: 1px 4px 7px 0px rgba(0, 0, 0, 0.77);
}

.form {
  margin-top: 67px;
}

.marges-page {
  position: relative;
  height: 100vh;
  padding: 0 52px;
  z-index: 101;

  * {
    box-sizing: border-box;
  }
}

.fond-panneau {
  position: absolute;
  left: 22%;
  top: 57px;
  right: 52px;
  bottom: 57px;
  z-index: -1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background-color: #fff;
  box-shadow: 3px 3px 20px -3px #000;
  z-index: 1;
}

.panneau {
  padding: 57px 0;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  padding-left: 0px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  z-index: 2;
}

.info-pane__col1,
.info-pane__col2,
.info-pane__col3 {
  height: calc(100vh - 114px);
  overflow-y: auto;
}

.info-pane__col1 {
  position: relative;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-pane__col2 {
  width: 30%;
  padding-top: 240px;
  padding-left: 50px;
}

.info-pane__col3 {
  width: 30%;
  margin-left: 0px;
  padding-right: 46px;
  padding-bottom: 2px;
  padding-top: 240px;
  padding-left: 50px;
}

.form-label {
  display: inline-block;
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: #000;
  font-size: 23px;
  line-height: 27px;
  font-weight: 500;
  text-transform: none;
}

.primary-btn {
  display: inline-block;
  margin-top: 42px;
  padding: 15px;
  background-color: #000;
  font-size: 25px;
  font-weight: 900;
}

.item-info__description {
  margin-top: 30px;
  margin-bottom: 46px;
  color: #000;
  font-size: 23px;
  line-height: 27px;
  font-weight: 500;
  text-align: left;
}

.form-textarea {
  height: 146px;
  margin-bottom: 0px;
  border-color: transparent;
  background-color: #ededed;
}

.form-text[type='checkbox'] {
  display: inline-block;
  width: 30px;
  margin-right: 1em;
  transform: translateY(25%);
}

.info-pane__title-wrapper {
  position: relative;
  margin-right: 0px;
  padding: 0px 10px 0px 193px;
  background-color: transparent;
}

form input,
form .selectize-control {
  display: block;
  width: 100%;
  margin-bottom: 28px;
}

.selectize-input {
  background-color: #ededed;
  border: none;
  height: 35px;
}

form input[type='submit'] {
  color: white;
  width: auto;
  font-family: inherit;
}

form input[disabled='disabled'] {
  opacity: 0.5;
}

.form-text {
  height: 35px;
  border-style: none;
  border-color: transparent;
  background-color: #ededed;
  font-family: 'KranaFatB', sans-serif;
  font-size: 16px;
  padding: 0 12px;
}

.item-info {
  position: relative;
  overflow: auto;
  max-height: 700px;
}

.item-share__title {
  margin-top: 0;
  margin-bottom: 65px;
  color: #000;
  font-size: 35px;
  line-height: 44px;
  font-weight: 900;
}

.info-pane__photo-wrapper {
  position: relative;
  display: block;
}

.badge-magnifier-plus {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 76px;
  width: 76px;
  transform: translate(-50%, -50%);
  background-image: url('../assets/magnifier-plus.svg');
  pointer-events: none;
}

.mini-toastr__notification {

  &,
  * {
    font-family: 'KranaFatB', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  &.-success {
    background: #33A44D;
  }

  &.-error {
    background: #FF0000;
  }

}

</style>